import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';

class LightboxStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            activePage: 0,
            totalPages: 0,
        };
    }

    reduce(state, { source, action }) {
        if (source === 'LIGHTBOX_ACTION') {
            switch (action.type) {
            case 'OPEN_LIGHTBOX':
                if (!state.visible) {
                    state.visible = true;
                    this.__emitChange();
                }
                break;
            case 'CLOSE_LIGHTBOX':
                if (state.visible) {
                    state.visible = false;
                    this.__emitChange();
                }
                break;
            case 'GOTO':
                const pageNum = action.payload;
                if (pageNum < state.totalPages) {
                    state.activePage = pageNum;
                    this.__emitChange();
                }
                break;
            case 'GOTO_NEXT':
                if (state.activePage + 1 < state.totalPages) {
                    state.activePage += 1;
                    this.__emitChange();
                }
                break;
            case 'GOTO_PREV':
                if (state.activePage > 0) {
                    state.activePage -= 1;
                    this.__emitChange();
                }
                break;
            case 'TOTAL_PAGES_CHANGE':
                if (state.totalPages !== action.payload) {
                    state.totalPages = action.payload;
                    this.__emitChange();
                }
                break;
            }
        }

        return state;
    }
}

const LightboxStore = new LightboxStoreClass(Dispatcher);
export default LightboxStore;
